import { apiClient } from "../config";

async function getSurveyJsFormDetails(id: string) {
  const res = await apiClient.get(`/admin/dynamic-forms/${id}/form-builder`);
  return res.data;
}

export default getSurveyJsFormDetails;
